import { drawText, rgb, StandardFonts } from 'pdf-lib';

export const disclousurePdf = async (pdfDoc, data) => {
  // Replace [name]
  const page = pdfDoc.getPages()[0];
  const secondPage = pdfDoc.getPages()[1];
  const { width, height } = page.getSize();

  // const font = await pdfDoc.embedFont(StandardFonts.Helvetica, {
  //   subset: true,
  //   features: { liga: false },
  // });

  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 705, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 390, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const eSignature = `\t\t\tThese E-Signature Disclosures & Consent apply to all Materials, both current and future, related to your application for or possible employment with ${data.DSP_TRADENAME}.
  
  \t\t\tBy checking the box and clicking the “I Agree” button (all below), you are agreeing that your electronic signature is the equivalent of your handwritten (or “wet”) signature, with all the same legal and binding effect. In certain cases throughout your employment, you may be asked to click buttons labeled “I Agree,” “I Acknowledge,” or using similar words, or otherwise electronically to acknowledge, accept, review, etc. Materials.These E-Signature Disclosures & Consent apply to those instances as well. You also understand that, in its sole discretion, ${data.DSP_TRADENAME} may mail, hand-deliver, communicate, or otherwise send you hard-copy Materials.
  
  \t\t\tYou may obtain a paper copy of any electronic Materials, including ones already or to be accessed, received, reviewed, and/or signed electronically, by sending a written request to ${data.DSP_TRADENAME} at ${data.DSP_ADDRESS}.
  
  \t\t\tYou may withdraw your consent to receive, review, access, sign, and authenticate any additional electronic Materials at any time by canceling these E-Signature Disclosures & Consent. You may cancel these E-Signature Disclosures & Consent and withdraw your consent now by not completing this E-Signature Disclosures & Consent form and exiting the system. You may cancel these E-Signature Disclosures & Consent and withdraw your consent in the future by sending a written cancellation request to ${data.DSP_TRADENAME} at ${data.DSP_ADDRESS} or ${data.DSP_EMAIL}. Any withdrawal of your consent will be effective after a reasonable period of time in order for ${data.DSP_TRADENAME} to process your withdrawal. Withdrawal of your consent will have no legal effect on the validity, effectiveness, or enforceability of (a) any authorization, consent, or e-signature provided by you prior to the effective date of your withdrawal or (b) any document, form, letter, etc. that was provided or made available to you in electronic format prior to the effective date of your withdrawal. Withdrawal of your consent (i.e., canceling these E-Signature Disclosures & Consent) also will not relieve you from the obligation to complete all required Materials. Withdrawal/canceling will require you to receive, review, access, sign, and authenticate these Materials in `;
  page.drawText(eSignature, {
    x: 72, // X position of the placeholder
    y: height - 320, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    maxWidth: width / 1.3,
  });

  // //////
  secondPage.drawRectangle({
    x: 72, // X position of the background
    y: height - 168, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 60, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const secondText = `\t\t\tYou must update ${data.DSP_TRADENAME} regarding the information necessary to contact you electronically (including your personal email address) by calling ${data.DSP_TRADENAME} at ${data.DSP_CONTACT}, emailing ${data.DSP_EMAIL}.com If you are employed, ${data.DSP_TRADENAME} may electronically send Materials to your ${data.DSP_TRADENAME} email address or your personal email address, in its discretion. `;
  secondPage.drawText(secondText, {
    x: 72, // X position of the placeholder
    y: height - 120, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    maxWidth: width / 1.3,
  });
  const points = `1. Confirming that I can access these E-Signature Disclosures & Consent.\n2. Confirming that I have an email address and that the computer I intend to use to access documentselectronically has the hardware and software requirements described in these E-SignatureDisclosures & Consent, to access and to retain these electronic Materials.\n3. Agreeing to electronically access, receive, review, sign, and authenticate Materials related in anyway to my employment with ${data.DSP_TRADENAME} in place of hard copy/paper documents andhandwritten signatures.\n4. Confirming that I understand how to cancel these E-Signature Disclosures & Consent, should I everwant to do so.\n5. Consenting to update ${data.DSP_TRADENAME} regarding the information necessary to contact meelectronically (including my personal email address) by calling ${data.DSP_TRADENAME} at ${data.DSP_CONTACT},or emailing at ${data.DSP_EMAIL}.\n6. Agreeing that I have read, understand, and agree to all statements, agreements, andacknowledgements in these E-Signature Disclosures & Consent.`;
  //
  secondPage.drawRectangle({
    x: 72, // X position of the background
    y: height - 695, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 200, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  secondPage.drawText(points, {
    x: 72, // X position of the placeholder
    y: height - 500, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
    maxWidth: width / 1.3,
  });
  // Embed the ZapfDingbats font
  const zapfDingbatsFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

  // Use the correct glyph for a check mark
  const checkMark = String.fromCharCode('\u2714'); // ZapfDingbats glyph for ✓

  // Draw the check mark
  secondPage.drawText(`✔`, {
    x: 80, // X position of the placeholder
    y: 315, // Y position of the placeholder
    size: 14, // Text size
    color: rgb(0, 0, 0), // Black color
    font: zapfDingbatsFont, // Pass the font correctly
  });
  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      secondPage.drawSvgPath(pathString, {
        x: 140,
        y: 110,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
    });
  }
};
